import { NON_CONTEXTUAL_SOURCE_APPS } from 'automation-ui-source-apps/constants/WorkflowsAppSupportedSourceApps';
import { getEmbedSourceAppBestURL } from 'automation-ui-source-apps/utils/sourceAppLinkUtils';
export const getTemplateLibraryDirectUrl = ({
  portalId
}) => `/workflows/${portalId}/templates`;
export const getTemplateLibraryPreviewUrl = ({
  portalId,
  templateId
}) => `/workflows/${portalId}/templates/${templateId}`;
export const getWorkflowUrl = ({
  flowId,
  portalId,
  sourceApp,
  uuid
}) => {
  if (NON_CONTEXTUAL_SOURCE_APPS.includes(sourceApp)) {
    return `/workflows/${portalId}/platform/flow/${flowId}/edit`;
  }

  const embedSourceAppBestUrl = getEmbedSourceAppBestURL(sourceApp, uuid);

  if (embedSourceAppBestUrl) {
    return embedSourceAppBestUrl;
  }

  return undefined;
};
export const getWorkflowEditorUrl = ({
  flowId,
  portalId
}) => `/workflows/${portalId}/platform/flow/${flowId}/edit`;